import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import BodySelectionField from './BodySelectionField';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <BodySelectionField
        id={element.dataset.id}
        photo={element.dataset.photo}
        height={element.dataset.height}
        width={element.dataset.width}
        verticalOffset={element.dataset.verticalOffset}
        draft={element.dataset.draft === 'true'}
        levels={element.dataset.levels ? JSON.parse(element.dataset.levels) : null}
        values={element.dataset.values ? JSON.parse(element.dataset.values) : null}
      />
    </ErrorBoundary>,
  );
};
